import { Checkbox, Form, Input, Typography } from "antd";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { translation } from "../../../../i18n/translationConstant";
import { LoginSignupFormType } from "../../../../Utils/Constants/loginSignupFormTypes";
import { vuaIdSuffix } from "../../../../Utils/Constants/vuaIdSuffix";
import PinInputComponent from "../../../Common/Components/PinInput";
import "./index.css";

interface IUserProp extends WithTranslation {
  vuaIdValidator: (_: any, value: string) => void;
  isVuaIdDisabled?: boolean;
  vuaId?: string;
  form?: any;
}

const UserInformation: React.FC<IUserProp> = ({
  t,
  vuaIdValidator,
  vuaId,
  form,
  isVuaIdDisabled,
}) => {
  const onNameChange = (e: any) => {
    e.target.value = e.target.value.replace(/[^A-Za-z]+/g, "");
  };
  const onVUANameChange = (e: any) => {
    e.target.value = e.target.value.replace(/[^A-Za-z0-9]+/g, "");
  };

  let disableInputVuaId = false;
  if (!!vuaId) {
    console.log(vuaId);
    form.setFieldsValue({ vuaId });
    if (isVuaIdDisabled) {
      disableInputVuaId = true;
    }
  }

  return (
    <>
      <div className="flexCommonCss width">
        <Form.Item
          rules={[
            {
              required: true,
              message: t(translation.errorRequiredFirstName),
            },
          ]}
          name={LoginSignupFormType.firstName}
          className="inputCss1 formItemMarginBotton"
        >
          <Input
            id="firstName"
            type="text"
            onInput={onNameChange}
            placeholder={t(translation.lblFirstName)}
            allowClear={true}
            className="formItemPinInput"
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              message: t(translation.errorRequiredLastName),
            },
          ]}
          name={LoginSignupFormType.lastName}
          className="inputCss1 formItemMarginBotton"
        >
          <Input
            id="lastName"
            type="text"
            onInput={onNameChange}
            placeholder={t(translation.lblLastName)}
            allowClear={true}
            className="formItemPinInput"
          />
        </Form.Item>

        <Form.Item
          hasFeedback={true}
          rules={[
            {
              required: true,
              message: t(translation.errorEnterAAHandle),
            },
            {
              validator: vuaIdValidator,
            },
          ]}
          name={LoginSignupFormType.vuaId}
          className="inputCss1 formItemMarginBotton"
        >
          <Input
            id="vuaId"
            type="text"
            onInput={onVUANameChange}
            placeholder={t(translation.lblEnterAAHandle)}
            suffix={vuaIdSuffix.value}
            allowClear={true}
            disabled={disableInputVuaId}
            className="formItemPinInput"
          />
        </Form.Item>

        <PinInputComponent
          id="pin"
          label={t(translation.lblSetPin)}
          className="inputCss1"
        />
        <Form.Item
          valuePropName="checked"
          rules={[
            {
              validator: (_, checked) => {
                if (!checked) {
                  return Promise.reject(
                    new Error("Please agree to Terms and Conditions")
                  );
                } else {
                  return Promise.resolve();
                }
              },
            },
          ]}
          name={"terms"}
        >
          <Checkbox className="checkBox">
            <Typography.Text className="agreed">
              I agree to{" "}
              <Typography.Text className="termsAndCondition">
                <a
                  href="https://www.ink-aa.com/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms & Conditions
                </a>
              </Typography.Text>
            </Typography.Text>
          </Checkbox>
        </Form.Item>
      </div>
    </>
  );
};

export default withTranslation()(UserInformation);
